import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface RenderLeaveDialogData {
  // The archive being unpacked that would be lost.
  name: string;
}

// Asked when the upload step is left while an archive is still being unpacked (the designer's
// rule for the upload, 2026-10-16; the upload itself survives leaving since 2026-10-20). Closes
// with 'leave'; anything else — the button, Esc, a click beside it — keeps the page. The step
// closes it with 'leave' itself once the unpacking ends while it is open.
@Component({
  selector: 'app-render-leave-dialog',
  templateUrl: './render-leave-dialog.component.html',
  // The same card as "Unlock your pack".
  styleUrls: ['../unlock-dialog/render-unlock-dialog.component.scss'],
})
export class RenderLeaveDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: RenderLeaveDialogData,
    private readonly dialogRef: MatDialogRef<RenderLeaveDialogComponent, 'leave' | undefined>,
  ) {}

  public onLeave(): void {
    this.dialogRef.close('leave');
  }

  public onStay(): void {
    this.dialogRef.close();
  }
}
